import type { Translations } from '../types';

export const zhCN: Translations = {
    common: {
        save: '保存',
        cancel: '取消',
        delete: '删除',
        edit: '编辑',
        add: '添加',
        loading: '加载中...',
        error: '错误',
        success: '成功',
        confirm: '确认',
        yes: '是',
        no: '否',
        search: '搜索',
        noResults: '无结果',
        refresh: '刷新',
        logout: '退出登录',
        settings: '设置',
        download: 'Download',
    },
    nav: {
        chat: '聊天',
        gallery: '图库',
        settings: '设置',
        admin: '管理',
        users: '用户',
        models: '模型',
    },
    auth: {
        login: '登录',
        register: '注册',
        username: '用户名',
        password: '密码',
        currentPassword: '当前密码',
        newPassword: '新密码',
        confirmPassword: '确认密码',
        loginButton: '登录',
        registerButton: '注册',
        loggingIn: '登录中...',
        invalidCredentials: '用户名或密码错误',
        changePassword: '修改密码',
        changingPassword: '修改中...',
        passwordChanged: '密码已修改。其他设备已退出登录。',
        invalidateAllSessions: '退出所有设备',
        allSessionsInvalidated: '所有会话已失效。请重新登录。',
    },
    chat: {
        newChat: '新聊天',
        sendMessage: '发送',
        typeMessage: '输入消息...',
        noChats: '暂无聊天',
        startNewChat: '开始新聊天',
        deleteChat: '删除聊天',
        deleteChatConfirm: '确定删除此聊天？',
        deleteMessages: '删除消息',
        deleteMessageConfirm: '确定删除此消息？',
        exportChat: '导出聊天',
        importChat: '导入聊天',
        selectModel: '选择模型',
        thinking: '思考中...',
    },
    gallery: {
        title: '图库',
        description: '管理生成的图片和视频',
        upload: '上传',
        dragDrop: '拖放文件上传',
        delete: '删除',
        move: '移动',
        sync: '同步',
        noFiles: '暂无文件',
        syncComplete: '同步完成',
        uploadComplete: '上传完成',
        deleteConfirm: '确定删除所选文件？',
        newFolder: '新建文件夹',
        path: '路径',
        filename: '文件名',
        no_metadata: '无元数据',
        model: '模型',
        seed: '种子',
        size: '尺寸',
        sampler: '采样器',
        prompt: '提示词',
        negative_prompt: '负面提示词',
        ai_analyze: 'AI聊天分析',
        mode_image: '仅图片',
        mode_prompt: '仅提示词',
        mode_both: '图片+提示词',
        apply_settings: '应用生成设置',
    },
    settings: {
        title: '设置',
        apiKey: 'Google API密钥',
        apiKeyDesc: '用于Gemini API的API密钥',
        apiKeyPlaceholder: '以AIza开头的API密钥',
        apiKeySaved: 'API密钥已保存。',
        apiKeyRemoved: 'API密钥已删除。',
        removeApiKey: '删除API密钥',
        r2Config: 'R2存储设置',
        r2ConfigDesc: 'Cloudflare R2存储配置',
        r2Configured: 'R2已配置',
        r2SaveSuccess: 'R2设置已保存。',
        r2ChangeHint: '要更改R2设置，请重新填写以下表单。',
        autoSave: '自动保存媒体',
        autoSaveDesc: '自动将生成的图片/视频保存到R2',
        chatBackup: '聊天备份',
        exportAll: '导出全部',
        importAll: '导入全部',
        backupDesc: '将所有聊天和消息备份或恢复为JSON文件。',
        backupSuccess: '备份完成。',
        backupFailed: '备份失败。',
        importSuccess: '导入完成。',
        importFailed: '导入失败。',
        security: '安全',
        securityDesc: '密码修改和会话管理',
        passwordChangeHint: '修改密码后，其他设备的会话将自动退出。',
        sessionLogoutHint: '从所有其他设备退出。',
        systemPrompts: '系统提示词',
        addPrompt: '添加',
        promptTitle: '标题',
        promptContent: '内容',
        deletePromptConfirm: '确定删除此提示词？',
        clearCacheConfirm: '确定清除本地缓存？',
        clearCache: '清除缓存',
        clearCacheDesc: '确定清除本地缓存？UI状态将被重置。',
        cacheClearedRefresh: '缓存已清除。页面将刷新。',
    },
    admin: {
        users: {
            title: '用户管理',
            description: '创建和管理用户账户',
            addUser: '添加用户',
            username: '用户名',
            password: '密码',
            role: '角色',
            admin: '管理员',
            user: '用户',
            createdAt: '创建时间',
            actions: '操作',
            noUsers: '暂无注册用户',
            deleteConfirm: '确定删除此用户？',
            createFailed: '用户创建失败。',
            cannotDeleteSelf: '无法删除自己。',
            cannotChangeOwnRole: '无法更改自己的角色。',
            passwordMinLength: '密码至少需要8个字符。',
            passwordChanged: '密码已更改。',
            resetPassword: '重置密码',
            newPassword: '新密码（8位以上）',
            enterNewPassword: '的新密码：',
        },
        models: {
            title: '模型设置',
            description: '管理提供给用户的AI模型',
            fetchFromGoogle: '从Google获取',
            fetchModels: '获取模型',
            noModels: '暂无注册模型',
            noModelsDesc: '点击"从Google获取"按钮加载可用模型。',
            active: '启用',
            inactive: '禁用',
            modelsFetched: '模型获取完成',
            fetchFailed: '模型获取失败。请检查API密钥。',
            deleteConfirm: '确定删除此模型？',
            helpTitle: '帮助',
            helpItems: [
                '只有启用的模型才会显示给用户。',
                '"从Google获取"使用设置页面中保存的API密钥。',
                '模型列表由Google Gemini API提供。',
            ],
        },
    },
    time: {
        justNow: '刚刚',
        minutesAgo: '分钟前',
        hoursAgo: '小时前',
        daysAgo: '天前',
    },
    errors: {
        networkError: '网络错误',
        unauthorized: '需要认证',
        serverError: '服务器错误',
        notFound: '未找到',
        rateLimited: '请求过多，请稍后再试。',
    },
};
